<ngx-loading [show]="isSubmitting || loadingAddress" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>
<div class="dispute-dialog" #disputeFormContent>
  <h2 mat-dialog-title>Provider Request Form</h2>
  
  <mat-dialog-content class="dispute-content">
    <div class="row">
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Claim Number</mat-label>
          <input matInput 
                 [value]="data.claimId || 'CLM-2024-00001'" 
                 readonly>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Provider Dispute</mat-label>
          <mat-select [(ngModel)]="disputeForm.disputeType" required>
            <mat-option value="">Select type</mat-option>
            <mat-option *ngFor="let type of disputeTypes" [value]="type.value">
              {{type.label}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Dispute Reason</mat-label>
          <mat-select [(ngModel)]="disputeForm.disputeReason" required>
            <mat-option value="">Select a reason...</mat-option>
            <mat-option *ngFor="let reason of disputeReasons" [value]="reason.value">
              {{reason.label}}
            </mat-option>
          </mat-select>
          <!-- reason.value = queue (e.g. '5000'), reason.label = subtype (e.g. 'Benefit') -->
        </mat-form-field>
      </div>
    </div>
    
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Description of dispute</mat-label>
          <input matInput 
                 placeholder="Describe the dispute in detail..." 
                 [(ngModel)]="disputeForm.disputeDescription">
        </mat-form-field>
      </div>
    </div>
    
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Expected Outcome</mat-label>
          <input matInput 
                 placeholder="Describe the expected outcome..." 
                 [(ngModel)]="disputeForm.expectedOutcome">
        </mat-form-field>
      </div>
    </div>
    
    <h3 class="section-title">Provider Information</h3>
    <div class="row">
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Provider Name</mat-label>
          <input matInput 
                 placeholder="Provider Name"
                 [(ngModel)]="disputeForm.providerName"
                 readonly>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Title</mat-label>
          <input matInput 
                 placeholder="Title"
                 [(ngModel)]="disputeForm.title">
        </mat-form-field>
      </div>
    </div>
    
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Address</mat-label>
          <input matInput 
                 placeholder="Street address, City, State, ZIP"
                 [(ngModel)]="disputeForm.address"
                 readonly
                 >
        </mat-form-field>
      </div>
    </div>
    
    <div class="row">
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Region Code</mat-label>
          <input matInput 
                 placeholder="Region Code"
                 [(ngModel)]="disputeForm.regionCode"
                 readonly>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>NPI</mat-label>
          <input matInput 
                 placeholder="NPI"
                 [(ngModel)]="disputeForm.npi"
                 readonly>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>
  
  <div *ngIf="memberProviderError" class="member-provider-error">
    <span class="error-icon">&#9888;</span>
    {{ memberProviderError }}
  </div>

  <div *ngIf="submissionError" class="submission-error">
    <span class="error-icon">&#9888;</span>
    {{ submissionError }}
  </div>

  <mat-dialog-actions align="center">
    <button mat-stroked-button (click)="onCancel()">CANCEL</button>
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="isSubmitting || disputeAlreadySubmitted">
      Submit Request
    </button>
  </mat-dialog-actions>
</div>
